import image from '../assets/images/image.png'

export const Foo = () => (
  <>
    {/* Hero */}
    <div>
      <img className='w-full py-28'  src= {image} />
    </div>
    <div className="px-4 sm:px-6 lg:px-8  ">
  {/* Grid */}
  <div className="grid md:grid-cols-2 gap-4 md:gap-8 xl:gap-20 md:items-center">
    <div>
      <h1 className="block text-3xl font-bold text-gray-800 sm:text-4xl lg:text-6xl lg:leading-tight ">
        <span className="text-yellow-600">特別キャンペーン！</span><br />
        <span className="text-gray-800">ビタミンCサプリメント 25%OFF</span>
      </h1>
      <p className="mt-3 text-lg text-gray-800 ">
        <strong>免疫力を強化し、美しい肌へ。高品質なビタミンCで、毎日をもっと健康に！</strong><br />
        今だけの限定割引！在庫がなくなる前にお早めに！
      </p>

      {/* Trust Badges - 日本伝統デザイン */}
      <div className="mt-5 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2 bg-red-100  px-3 py-2 rounded-lg border border-red-600">
          {/* <img src="/icons/jp-gmp.svg" alt="GMP認証" className="h-6 w-6" /> */}
          <span className="text-sm font-medium text-red-700 ">GMP認証</span>
        </div>
        <div className="flex items-center gap-2 bg-gold-100 px-3 py-2 rounded-lg border border-gold-500">
          {/* <img src="/icons/jp-made.svg" alt="日本製" className="h-6 w-6" /> */}
          <span className="text-sm font-medium text-gold-700 ">日本製</span>
        </div>
        <div className="flex items-center gap-2 bg-green-100  px-3 py-2 rounded-lg border border-green-600">
          {/* <img src="/icons/jp-organic.svg" alt="オーガニック認証" className="h-6 w-6" /> */}
          <span className="text-sm font-medium text-green-700 ">オーガニック認証</span>
        </div>
        <div className="flex items-center gap-2 bg-blue-100 px-3 py-2 rounded-lg border border-blue-600">
          {/* <img src="/icons/jp-traditional.svg" alt="伝統製法" className="h-6 w-6" /> */}
          <span className="text-sm font-medium text-blue-700 ">伝統製法</span>
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-7 grid gap-3 w-full sm:inline-flex">
        <a
          className="py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-yellow-600 text-white hover:bg-yellow-700 focus:outline-hidden focus:bg-red-700 disabled:opacity-50 disabled:pointer-events-none"
          href="/#sell"
        >
          今すぐ購入
          <svg
            className="shrink-0 size-4"
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </a>
        <p className="mt-3 text-sm text-red-500 font-bold">
          <strong>終了まであと48時間！</strong> お得なチャンスをお見逃しなく！
        </p>
      </div>
      </div>

 

   
          {/* End Buttons */}
          {/* Review */}
      
          {/* End Review */}
     
        {/* End Col */}
        <div className="relative ms-4">
          <img
            className="w-full rounded-md"
            src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_002-xl.webp"
            alt="Hero Image"
          />
          <div className="absolute inset-0 -z-1 bg-linear-to-tr from-gray-200 via-white/0 to-white/0 size-full rounded-md mt-4 -mb-4 me-4 -ms-4 lg:mt-6 lg:-mb-6 lg:me-6 lg:-ms-6 " />
          {/* SVG*/}
          <div className="absolute bottom-0 start-0">
            <svg
              className="w-2/3 ms-auto h-auto text-white "
              width={630}
              height={451}
              viewBox="0 0 630 451"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x={531}
                y={352}
                width={99}
                height={99}
                fill="currentColor"
              />
              <rect
                x={140}
                y={352}
                width={106}
                height={99}
                fill="currentColor"
              />
              <rect
                x={482}
                y={402}
                width={64}
                height={49}
                fill="currentColor"
              />
              <rect
                x={433}
                y={402}
                width={63}
                height={49}
                fill="currentColor"
              />
              <rect
                x={384}
                y={352}
                width={49}
                height={50}
                fill="currentColor"
              />
              <rect
                x={531}
                y={328}
                width={50}
                height={50}
                fill="currentColor"
              />
              <rect x={99} y={303} width={49} height={58} fill="currentColor" />
              <rect x={99} y={352} width={49} height={50} fill="currentColor" />
              <rect x={99} y={392} width={49} height={59} fill="currentColor" />
              <rect x={44} y={402} width={66} height={49} fill="currentColor" />
              <rect
                x={234}
                y={402}
                width={62}
                height={49}
                fill="currentColor"
              />
              <rect
                x={334}
                y={303}
                width={50}
                height={49}
                fill="currentColor"
              />
              <rect x={581} width={49} height={49} fill="currentColor" />
              <rect x={581} width={49} height={64} fill="currentColor" />
              <rect
                x={482}
                y={123}
                width={49}
                height={49}
                fill="currentColor"
              />
              <rect
                x={507}
                y={124}
                width={49}
                height={24}
                fill="currentColor"
              />
              <rect x={531} y={49} width={99} height={99} fill="currentColor" />
            </svg>
          </div>
          {/* End SVG*/}
        </div>
        {/* End Col */}
      </div>
      {/* End Grid */}
    </div>


 

    {/* End Hero */}
  </>

  
)
export default Foo